// Role definitions
export type UserRole = "user" | "admin" | "super_admin";

export const ROLE_HIERARCHY: UserRole[] = ["user", "admin", "super_admin"];

// Permission definitions
export type Permission =
  // User permissions
  | "video:create"
  | "video:read"
  | "video:update"
  | "video:delete"
  | "video:share"
  // Admin permissions
  | "admin:view_all_videos"
  | "admin:manage_users"
  | "admin:view_analytics"
  | "admin:manage_subscriptions"
  // Super admin permissions
  | "super_admin:assign_roles"
  | "super_admin:system_config";

export interface UserRoleData {
  userId: string;
  role: UserRole;
  createdAt?: string;
  updatedAt?: string;
}

export interface User {
  id: string;
  firstName: string | null;
  lastName: string | null;
  email: string;
  imageUrl: string;
  lastSignInAt: number | null;
  createdAt: number;
  role?: UserRole;
}

// API Response Interfaces

export interface GetMyRoleResponse {
  userId: string;
  role: UserRole;
  permissions: Permission[];
}

export interface GetUserRoleResponse {
  userId: string;
  role: UserRole;
}

export interface SetUserRoleResponse {
  userId: string;
  role: UserRole;
  message: string;
}

export interface DeleteUserRoleResponse {
  userId: string;
  message: string;
}

export interface ListUserRolesResponse {
  users: UserRoleData[];
  total: number;
}

export interface GetUsersResponse {
  users: (User & { role: UserRole })[];
  total: number;
}

export interface GetPermissionsResponse {
  roles: Record<UserRole, Permission[]>;
}

export interface AddQuotaRequest {
  userId: string;
  amount: number; // Positive integer
}

export interface AddQuotaResponse {
  message: string;
  userId: string;
  addedAmount: number;
  newLimit: number;
}
